import React from 'react'

const System = () => {
	return <div>System</div>
}

export default System
